<template>
  <div>
    <div ref="loadingScreen" :class="{ 'loading-screen': showLoadingScreen, 'loading-screen fade-out': !showLoadingScreen }">
      <div v-if="showLoadingScreen" class="loading-icon"></div>
    </div>
    <b-icon
      v-b-toggle.sidebar-right
      icon="justify"
      variant="primary"
      class="h2 position-fixed"
      style="cursor: pointer; top: 20px; right: 20px; z-index: 10000;"
      @click="showSideBarOnClick"
    ></b-icon>

    <b-sidebar
      ref="sidebarRight"
      id="sidebar-right"
      right
      shadow
      :no-header-close="true"
      :visible="true"
      style="z-index: 10001;"
    >
      <template #header="{ hide }">
        <b-button variant="outline-default" @click="hide" class="position-absolute" style="right: 20px; top: 15px; padding: 0; background: white; z-index: 1000;">
          <b-icon
            v-b-toggle.sidebar-right
            icon="x-lg"
            @click="hideSideBarOnClick"
            style="padding: 5px 5px 5px 6px; box-sizing: content-box; border: 1px solid #00000060; border-radius: 5px;"
          ></b-icon>
        </b-button>
      </template>
      <template #default>
        <div class="px-3 py-2">
          <div class="mb-3">
            <div v-if="company">
              <!-- Display company name -->
              <label class="form-label font-weight-bold mt-4" style="font-size:2rem;">{{ company.name }}</label>

              <p class="text-primary">訂閱制點數：{{ companyPoints.total_points }} 點 <span v-if="companyPoints.total_points" class="text-secondary">({{ companyPoints.end_date }} 到期)</span></p>
              <p style="font-size: 1.4rem;"><strong>歡迎使用 IRUAV APP</strong></p>
              <a href="https://iruav.com.tw/docs/iruav-app-instructions/" target="_blank">使用說明</a>

              <b-row class="mt-2">
                <b-col>
                  <b-form-group
                    label="縣市"
                  >
                    <b-form-select
                      v-model="city"
                      :options="resources.citys"
                      @change="getCompany"
                    >
                      <template #first>
                        <b-form-select-option :value="null">-- 全部 --</b-form-select-option>
                      </template>
                    </b-form-select>
                  </b-form-group>
                </b-col>
                <b-col>
                  <b-form-group
                    label="併網年份"
                  >
                    <b-form-select
                      v-model="mergeYear"
                      :options="resources.mergeYears"
                      @change="getCompany"
                    >
                      <template #first>
                        <b-form-select-option :value="null">-- 不限 --</b-form-select-option>
                      </template>
                    </b-form-select>
                  </b-form-group>
                </b-col>
                <b-col>
                  <b-form-group
                    label="模組廠牌"
                  >
                    <b-form-select
                      v-model="moduleBrand"
                      :options="resources.moduleBrands"
                      @change="getCompany"
                    >
                      <template #first>
                        <b-form-select-option :value="null">-- 不限 --</b-form-select-option>
                      </template>
                    </b-form-select>
                  </b-form-group>
                </b-col>
              </b-row>

              <!-- Display total number of case scenes -->
              <p style="font-size: 1.2rem;">目前有 <strong>{{ caseScenes.length }}</strong> 座案場檢測資料</p>
              <!-- Display case scenes -->
              <b-row>
                <b-col
                  v-for="caseScene in caseScenes"
                  :key="caseScene.id"
                  cols="12"
                  sm="6"
                  md="6"
                  lg="4"
                  xl="4"
                >
                  <figure
                    v-if="caseScene.has_detection === 1"
                    class="figure"
                  >
                    <a
                      @click="navigateToCaseScene(caseScene.id)"
                      href="#"
                      class="position-relative"
                    >
                      <span class="position-absolute" style="top: 50%; left: 50%; margin-top: -12px; margin-left: -16px; color: white; background-color: rgba(0, 0, 0, 0.5);">檢視</span>
                      <img :src="`https://${rootUrl}/uploads/case-scene-photos/${caseScene.case_scene_photo}`" class="figure-img img-fluid rounded">
                    </a>

                    <figcaption class="figure-caption text-center">{{ caseScene.name }} {{ caseScene.device_capacity }} {{ caseScene.capacity_unit }} <a :href="`https://maps.google.com/maps?t=k&q=${caseScene.latitude}+${caseScene.longitude}`" class="d-inline-block" target="_blank">導航</a></figcaption>
                  </figure>
                  <figure
                    v-else
                    class="figure position-relative"
                  >
                    <span class="position-absolute" style="top: 50%; left: 50%; margin-top: -12px; margin-left: -16px; color: white; background-color: rgba(0, 0, 0, 0.5);">檢視</span>
                    <img :src="`https://${rootUrl}/uploads/case-scene-photos/${caseScene.case_scene_photo}`" class="figure-img img-fluid rounded">
                    <figcaption class="figure-caption text-center">{{ caseScene.name }} {{ caseScene.device_capacity }} {{ caseScene.capacity_unit }} <a :href="`https://maps.google.com/maps?t=k&q=${caseScene.latitude}+${caseScene.longitude}`" class="d-inline-block" target="_blank">導航</a></figcaption>
                  </figure>
                </b-col>
              </b-row>
            </div>
          </div>

          <b-row id="sidebar-buttons">
            <b-col cols="12" class="text-right">
              <b-button-group>
                <a v-if="isAdmin" href="/admin/company">
                  <b-button title="返回管理面板" style="border-radius: .375rem 0 0 .375rem;">
                    <b-icon icon="gear"></b-icon>
                  </b-button>
                </a>
                <b-button title="登出帳號" @click="logout()">
                  <b-icon icon="door-open"></b-icon>
                </b-button>
              </b-button-group>
            </b-col>
          </b-row>
        </div>
      </template>
    </b-sidebar>

    <b-row>
      <b-col cols="8">
        <div id="image-map-pro"></div>
      </b-col>
      <b-col>
      </b-col>
    </b-row>
  </div>
</template>

<script>

export default {
  data() {
    const rootUrl = 'platform.iruav.com.tw';
    return {
      company: null,
      caseScenes: [],
      sidebar: true,
      rootUrl: rootUrl,
      showLoadingScreen: true,
      isAdmin: false,
      companyPoints: 0,

      city: null,
      mergeYear: null,
      moduleBrand: null,
      resources: {
        citys: [],
        mergeYears: [],
        moduleBrands: []
      },
      imageMapPro: {
        id: "imp-main",
        fullscreen: {
          enable_fullscreen_mode: true,
          vstart_in_fullscreen_mode: true,
          start_in_fullscreen_mode: true,
        },
        objectConfig: {
          pageload_animation: "flash",
          glowing_objects: true,
        },
        tooltips: {
          sticky_tooltips: true,
          fullscreen_tooltips: "none",
        },
        zooming: {
          enable_zooming: true,
          max_zoom: 20,
          zoom_on_object_click: true,
          hold_ctrl_to_zoom: false,
        },
        artboards: [
          {
            title: "台灣地圖",
            background_type: "image",
            image_url: `https://${rootUrl}/uploads/taiwan-map-new.jpg`,
            use_image_size: true,         
            children: [],
          },
        ],
        version: "6.0.18",
        general: {
          name: "imp-case-scene",
        },
      },
    };
  },
  
  methods: {
    /**
     * Handle right sidebar close
     */
     hideSideBarOnClick() {
      let impCanvas = document.querySelector('[data-image-map-name="imp-case-scene [fullscreen]"] .imp-canvas');
      if (impCanvas) {
        impCanvas.style.marginLeft = "0px";
      }
    },

    /**
     * Handle right sidebar open
     */
    showSideBarOnClick() {
      let impCanvas = document.querySelector('[data-image-map-name="imp-case-scene [fullscreen]"] .imp-canvas');
      if (impCanvas) {
        impCanvas.style.marginLeft = "-500px";
      }
    },
    
    /**
     * Initialize Image Map Pro
     */
    setImageMapPro() {
      this.imageMapPro.artboards[0].children = this.caseScenes.map(caseScene => {
        let { x, y } = this.relativePos(caseScene.latitude, caseScene.longitude);
        let actions = {};
        if (caseScene.has_detection === 1) {
          actions = {
            click: "run-script",
            script: `localStorage.setItem('CaseSceneId', JSON.stringify(${caseScene.id})); window.location.href = '/case-scene';`,
          };
        }
        return {
          id: `imp-siteid-${caseScene.id}`,
          title: `siteid-${caseScene.id}`,
          x: x,
          y: y,
          default_style: {
            icon_size: 20,
            icon_svg: '<svg xmlns="http://www.w3.org/2000/svg" style="stroke: #fff;  stroke-width: 20px;" viewBox="0 0 384 512"><!--! Font Awesome Free 6.1.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free (Icons: CC BY 4.0, Fonts: SIL OFL 1.1, Code: MIT License) Copyright 2022 Fonticons, Inc. --><path d="M168.3 499.2C116.1 435 0 279.4 0 192C0 85.96 85.96 0 192 0C298 0 384 85.96 384 192C384 279.4 267 435 215.7 499.2C203.4 514.5 180.6 514.5 168.3 499.2H168.3zM192 256C227.3 256 256 227.3 256 192C256 156.7 227.3 128 192 128C156.7 128 128 156.7 128 192C128 227.3 156.7 256 192 256z"/></svg>',
            icon_fill: "#FF0000",
          },
          tooltip_style: {
            position: "left",
          },
          tooltip_content: [
            {
              type: 'Image',
              url: `https://${this.rootUrl}/uploads/case-scene-photos/${caseScene.case_scene_photo}`,
              linkUrl: '',
              other: {
                id: '',
                classes: '',
                css: 'max-width:320px;',
              },
              boxModel: {
                width: 'auto',
                height: 'auto',
                margin: {
                  top: 0,
                  bottom: 0,
                  left: 0,
                  right: 0,
                },
                padding: {
                  top: 10,
                  bottom: 10,
                  left: 10,
                  right: 10,
                },
              },
              id: null,
            },
            {
              type: "Paragraph",
              text: caseScene.name + " " + caseScene.device_capacity + caseScene.capacity_unit,
              other: {
                id: "",
                classes: "",
                css: "text-align:center;",
              },
              style: {
                fontFamily: "sans-serif",
                fontSize: 14,
                lineHeight: "normal",
                color: "#ffffff",
                textAlign: "left",
              },
              boxModel: {
                width: "auto",
                height: "auto",
                margin: {
                  top: 0,
                  bottom: 0,
                  left: 0,
                  right: 0,
                },
                padding: {
                  top: 10,
                  bottom: 10,
                  left: 10,
                  right: 10,
                },
              },
              id: `imp-tooltip-siteid-${caseScene.id}`,
            },
          ],
          actions: actions,
        };
      });

      // Run Image Map Pro here, after all spots have been loaded
      window.ImageMapPro.init("#image-map-pro", this.imageMapPro);

      /**
       * This is the function that loops until fullscreen container is detected
       */
      let impCanvas = null;
      let intervalCanvas = setInterval(() => {
        impCanvas = document.querySelector('#imp-fullscreen-image-map .imp-canvas');
        if (impCanvas) {
          clearInterval(intervalCanvas);  // Stop the interval once the element is found
          var impContainer = document.querySelector("#imp-fullscreen-container");
          impContainer.style.background = "#9cc0fa";
          impCanvas.style.marginLeft = '-500px';
          impCanvas.style.transition = 'margin-left 0.5s ease';
        }
      }, 200);

      /**
       * This is the function that loops until fullscreen button is detected
       */
      let impButton = null;
      let intervalButton = setInterval(() => {
        impButton = document.querySelector('#imp-fullscreen-image-map .imp-fullscreen-button');
        if (impButton) {
          clearInterval(intervalButton);  // Stop the interval once the element is found
          impButton.style.display = 'none';
          
          // Remove loading screen 
          if (this.showLoadingScreen) { 
            this.removeLoadingScreen();
          }
        }
      }, 200);
    },

    /**
     * Functions to calculate position on map based on longitude and latitude
     */ 
    deg2xy(lat, lng) {
      const zoom = 10;
      const tile_x = 850;
      const tile_y = 437;
      const tile_size = 256;
      // Use a left shift to get the power of 2
      // i.e. a zoom level of 2 will have 2^2 = 4 tiles
      const numTiles = 1 << zoom;
      // Find the x_point given the longitude
      const point_x = (tile_size / 2 + lng * tile_size / 360.0) * numTiles - tile_size * tile_x;
      // Convert the latitude to radians and take the sine
      const sin_y = Math.sin(lat * (Math.PI / 180.0));
      // Calulate the y coorindate
      const point_y = tile_size * (0.5 - Math.log((1 + sin_y) / (1 - sin_y)) / (4 * Math.PI)) * numTiles - tile_size * tile_y;
      return { x: point_x, y: point_y };
    },
    relativePos(lat, lng) {
      const w = 3072;
      const h = 3072;
      const { x: x0, y: y0 } = this.deg2xy(lat, lng);
      const x1 = x0 + 0;
      const y1 = y0 - 0;

      return { x: (x1 / w) * 100, y: (y1 / h) * 100 };
    },

    /**
     * Get company data
     */     
    getCompany() {
      //let companyId = localStorage.getItem('CompanyId');
      const userData = JSON.parse(localStorage.getItem('user'));
      let companyId = userData.company_id;
      let isAdmin = userData.admin;

      if (isAdmin === 1) {
        this.isAdmin = true;
      }

      this.axios.get('/taiwan-map', {
        params: {
          filter: `id:${companyId}${this.city ? ',city:' + this.city : ''}${this.mergeYear ? ',merge_date:' + this.mergeYear : ''}${this.moduleBrand ? ',module_brand:' + this.moduleBrand : ''}`
        }
      })
      .then(response => {
        const responseData = response.data.data[0];
        this.company = responseData.company;
        this.caseScenes = responseData.case_scenes;
        this.setImageMapPro();
        
        this.fetchCompanyTotalPoints(companyId);

        if (this.resources.citys.length === 0) {
          for (let i = 0, len = this.caseScenes.length; i < len; i++) {
            if (!this.resources.citys.find(element => element === this.caseScenes[i].city)) {
              this.resources.citys.push(this.caseScenes[i].city)
            }

            if (!this.resources.mergeYears.find(element => element === this.caseScenes[i].merge_date.substr(0, 4))) {
              this.resources.mergeYears.push(this.caseScenes[i].merge_date.substr(0, 4))
            }

            if (!this.resources.moduleBrands.find(element => element === this.caseScenes[i].module_brand)) {
              this.resources.moduleBrands.push(this.caseScenes[i].module_brand)
            }
          }

          this.resources.citys.sort()
          this.resources.mergeYears.sort()
          this.resources.moduleBrands.sort()
        }
      })
      .catch(error => {
        console.error('Error fetching data:', error);
      });
    },

    /**
     * Fetch total points for the company
     */   
    fetchCompanyTotalPoints(companyId) {   
      this.axios.get('/points-history/total', {
        params: {
          filter: `company_id:${companyId},action:1`
        }
      })
      .then(response => {
        // const totalPoints = response.data.data.total_points || 0;
        this.companyPoints = response.data.data;
      })
      .catch(error => {
        console.error('Error fetching total points:', error);
      });
    },

    /**
     * Navigate to casce scene page
     */     
    navigateToCaseScene(caseSceneId) {
      localStorage.setItem('CaseSceneId', JSON.stringify(caseSceneId));
      window.location.href = '/case-scene';
    },

    /**
     * Remove loading screen
     */         
    removeLoadingScreen() {
      this.showLoadingScreen = false;
      setTimeout(() => {
        const loadingScreen = this.$refs.loadingScreen;
        if (loadingScreen) {
          loadingScreen.remove();
        }
      }, 500);
    },

    /**
     * Logout
     */   
    logout () {
      const config = {
        headers: { Authorization: `Bearer ${ localStorage.getItem('token') }` }
      };

      this.axios
        .get('/logout', config)
        .then((response) => {
          if (response.status === 200) {
            localStorage.removeItem('token');
            localStorage.removeItem('user');

            this.$store.commit('setToken', null);
            this.$store.commit('setUser', {});

            // Important, remove Image Map Pro element with id "imp-fullscreen-container"
            const element = document.getElementById('imp-fullscreen-container');
            if (element) {
              element.parentNode.removeChild(element);
            }

            // Redirect to login page
            this.$router.push({ path: '/login' });
          } else {
            console.error('Logout failed:', response.data); // Log response data for debugging
          }
        })
        .catch(error => {
          console.error('Logout error:', error);
        });
    },
  },

  mounted() {
    /**
     * Function to prevent drag and drop of the map if the mouse is on the sidebar
     */
    var sidebar = this.$refs.sidebarRight.$el;
    sidebar.addEventListener('mousedown', function(event) {
      event.stopPropagation();
    });

    /**
     * Prevent touch events and wheel events from propagating to the map
     */
    sidebar.addEventListener('touchmove', (event) => {
      event.stopPropagation();
    }, { passive: false });
    sidebar.addEventListener('wheel', (event) => {
      event.stopPropagation();
    });

    /**
     * Function to solve the esc problem: reload the map
     */
     document.addEventListener('keyup', (event) => {
      if (event.key === 'Escape') {
        event.preventDefault();
        event.stopPropagation();
        // Reload Image Map Pro
        this.setImageMapPro();
        // In case we are on the right sidebar, it will close on esc, we need to open it again
        setTimeout(() => {
          sidebar.style.display = "block"; 
        }, 2000); 
      }
    });

    /**
     * Load company data
     */
    this.getCompany();
  },
};
</script>

<style scoped>
.b-icon.bi-justify {
  background: white;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.15);
  border: 1px solid #00000060;
  border-radius: 5px;
  fill: black;
}
.b-sidebar-outer >>> #sidebar-right {
  width: 100%;
  padding-bottom: 33px;
}
/* desktop */
@media (min-width: 960px) {
  .b-sidebar-outer >>> #sidebar-right {
    width: 500px;
  }
}
#sidebar-buttons {
  position: absolute;
  bottom: 20px;
  right: 30px;
}
.loading-screen {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: #100c2a;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 24px;
  z-index: 20000;
  transition: opacity .5s; 
  opacity: 1;
}
.loading-screen.fade-out {
  opacity: 0;
}
.loading-icon {
  border: 4px solid #f3f3f3; /* Light grey */
  border-top: 4px solid #3498db; /* Blue */
  border-radius: 50%;
  width: 30px;
  height: 30px;
  animation: spin 1s linear infinite; /* Spin animation */
  margin: auto auto; /* Center the icon */
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}
</style>
